export default "__VITE_ASSET__DjWxv$hV__"